import type { Episode } from '@/lib/contract';
import { cn } from '@/lib/cn';

const LABELS: Record<Episode['qa_state'], string> = {
  verified: 'Verified',
  sampled: 'Sampled',
  not_sampled: 'Not sampled'
};

const TONES: Record<Episode['qa_state'], string> = {
  verified: 'text-pass',
  sampled: 'text-muted',
  not_sampled: 'text-dim'
};

/** Episode QA state. States reflect a bounded sample, never a full census. */
export function QaState({ state, className }: { state: Episode['qa_state']; className?: string }) {
  return (
    <span className={cn('font-mono text-[10px] tracking-[0.1em] uppercase', TONES[state], className)}>
      {LABELS[state]}
    </span>
  );
}
